<template>
  <div
    class="tag-content-wrap"
    :class="{ large: showName }"
    @click="$emit('click')"
  >
    <em
      :style="icon"
      class="custom-icons tags-icon"
      :class="{ small: !showName }"
    />
    <span
      v-if="showName"
      class="tag-name usn"
    >
      {{ name }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'CardTagContent',
  props: {
    name: {
      type: String,
      required: true,
    },
    showName: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  emits: ['click'],
};
</script>

<style lang="scss">
.tag-content-wrap {
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;

  &.large {
    min-height: 24px;
  }

  .tag-name {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-overflow: ellipsis;
    overflow: hidden;
    @apply text-text-default;
  }
}
</style>
